import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

@Component({
    selector: "app-input-switch",
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SwitchComponent,
            multi: true
        }
    ]
})
export class SwitchComponent {
    @Input() offLabel = '';
    @Input() onLabel = '';
    @Input() topLabel = '';
    @Input() disabled = false;
    @Input() formControl: UntypedFormControl;
    @Input() tooltipText = '';
    @HostBinding('class.inline') @Input() inline = false;


    @Output() inputChange = new EventEmitter<any>();


    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    private _value = false;

    get value() {
        return !!this._value;
    }

    set value(val) {
        this._value = val;
        if (this.onChangeCallback) {
            this.onChangeCallback(this._value);
        }
    }

    writeValue(value) {
        this._value = !!value;
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

    onChange(val: any) {
        this._value = val;
        this.inputChange.emit(this._value);
    }
}
